import Store from "./Store";
import AppStore from "./AppStore";
import { runInAction } from "mobx";
import TrainingBudget, { ITrainingBudget } from "../models/TrainingBudgetModal";

export default class TrainingBudgeStore extends Store<
ITrainingBudget,
TrainingBudget
> {
  [x: string]: any;
  items = new Map<string, TrainingBudget
  >();

  constructor(store: AppStore) {
    super(store);

    this.store = store;
  }

  load(items: ITrainingBudget[] = []) {
    runInAction(() => {
      items.forEach((item) =>
        this.items.set(item.id, new TrainingBudget(this.store, item))
      );
    });
  }
}
